import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import { formatPrice, statusColor, statusLabel } from '../utils/helpers';
import './OrderHistoryPage.css';

const OrderHistoryPage = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/orders/myorders').then(({ data }) => setOrders(data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', padding: '120px' }}><div className="spinner" /></div>;

  return (
    <div className="orders-page">
      <div className="container">
        <div className="orders-header">
          <h1>My <span className="gradient-text">Orders</span></h1>
          <p>{orders.length} order{orders.length !== 1 ? 's' : ''}</p>
        </div>

        {orders.length === 0 ? (
          <div className="no-orders">
            <div className="no-orders-icon">📦</div>
            <h3>No orders yet</h3>
            <p>Start shopping to see your orders here</p>
            <Link to="/products" className="btn btn-primary">Shop Now</Link>
          </div>
        ) : (
          <div className="orders-list">
            {orders.map(order => (
              <Link key={order._id} to={`/orders/${order._id}`} className="order-card card">
                <div className="order-card-header">
                  <div>
                    <span className="order-id">#{order._id.slice(-8).toUpperCase()}</span>
                    <span className="order-date">{new Date(order.createdAt).toLocaleDateString('en-BD', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
                  </div>
                  <span className={`badge ${statusColor(order.orderStatus)}`}>{statusLabel(order.orderStatus)}</span>
                </div>

                <div className="order-items-preview">
                  {order.items?.slice(0, 3).map((item, i) => (
                    <div key={i} className="order-item-preview">
                      <img src={item.thumbnail || 'https://via.placeholder.com/50'} alt={item.name} />
                    </div>
                  ))}
                  {order.items?.length > 3 && (
                    <div className="order-more">+{order.items.length - 3}</div>
                  )}
                </div>

                <div className="order-card-footer">
                  <div>
                    <span className="order-items-count">{order.items?.length} item{order.items?.length > 1 ? 's' : ''}</span>
                    {order.isPreOrder && <span className="preorder-badge">Pre-Order</span>}
                  </div>
                  <span className="order-total">{formatPrice(order.totalPrice)}</span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderHistoryPage;
